export function lockedShippingSelection(compareSite: string, compareUrl: string): boolean | null {
  if (compareSite === "direct") return null;
  try {
    const url = new URL(compareUrl);
    if (compareSite === "danawa") return url.searchParams.get("deliveryYN") === "Y";
    if (compareSite === "enuri") return url.searchParams.get("toggle") === "delivery";
    if (compareSite === "naver" && url.pathname.startsWith("/catalog/")) return true;
  } catch {
    if (compareSite === "danawa" || compareSite === "enuri") return false;
  }
  return null;
}
